import { Button, Center, Container, Title } from "@mantine/core";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";


export function MobileRedirectSuccess() {

	const params = useLocation().search
	const message = new URLSearchParams(params).get("msg")
	const handleBackToApp = () => {
		if (window.ReactNativeWebView) {
			window.ReactNativeWebView.postMessage(
				JSON.stringify({
					status: "success",
					message: message,
				}),
			);
		}
		window.location.href = "falcomm://home";
	}

	useEffect(() => {
		handleBackToApp()
	}, []);

	return <div
		style={{
			height: "100vh",
			width: "100vw",
		}}
	>
		<Container>
			<Center style={{ flexDirection: 'column' }} py={40}>
				<Title className="text-center" order={2} w='fit-content' ta='center'>
					Success
				</Title>
				<p>
					{message}
				</p>
				<div>
					<Button onClick={handleBackToApp} size='sm'>
						Back to App
					</Button>
				</div>
			</Center>
		</Container>
	</div>
}